







import { defineComponent } from "@vue/composition-api";
interface Props {
  iconName: string;
}

export default defineComponent({
  name: "Icon",
  props: {
    iconName: {}
  },
  setup(props: Props) {
    //
    return {
        iconId: `#icon-${props.iconName}`
    }
  }
});
